<template>
  <v-container fluid  v-if="asyncDataStatus_ready">
    <div class="dashboard-page">
      <v-card width="100%" class="breadcrumbs mx-1 mb-6">
        <v-row no-gutters class="d-flex align-center mt-8 mb-3 px-5 py-1 mx-1">
          <v-col cols="12" md="6" class="d-sm-flex justify-md-start justify-space-between align-center">
            <h1 class="main-page-title greyMedium--text mb-0 mr-2 pt-4 pt-md-0">Projetos</h1>
            <div class="py-6"></div>
          </v-col>
          <v-col cols="12" md="6" class="d-sm-flex justify-space-between align-center justify-md-end">
            <NovoProjeto v-if="isPermissao"></NovoProjeto>
          </v-col>
        </v-row>
      </v-card>
      <v-row>
        <v-col cols=12>
          <v-card class="support-table ma-1">
            <v-card-text class="pa-0 overflow-x-auto">
              <v-data-table
                :headers="headers"
                :items="items"
                no-results-text="Nenhuma projeto encontrada"
                no-data-text="Não há projetos registrados"
                :items-per-page="itemPerPage">
                
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="item in items" :key="item.id">
                      <td>
                        <router-link class="primaryConst--text" :to="{ name: 'Dashboard', params: { 'projetoId': item.id }}"> {{item.titulo}} </router-link>
                      </td>
                      <td> {{ formatarData(item.inicio) }} </td>
                      <td> {{ formatarData(item.termino) }} </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import asyncDataStatus from '@/mixins/asyncDataStatus'
import NovoProjeto from "./Novo/NovoProjeto"

export default {
  name: "Organizacoes",
  components: {
    NovoProjeto,
  },
  mixins: [asyncDataStatus],

  data() {
    return {
      headers: [
        { text: "Nome", value: "titulo" },
        { text: "Data de Início", value: "inicio" },
        { text: "Data de Término", value: "termino" },
      ],
      itemPerPage: 10,
    };
  },
  methods: {
    ...mapActions("projeto", ["fetchAllProjetos"]),

    formatarData (data) {
      if (!data) return null

      const [ano, mes, dia] = data.split('-')
      return `${dia}/${mes}/${ano}`
    },

  },
  computed: {
    items() {
      return this.$store.getters["projeto/all"];
    },
    isPermissao() {
      return this.$store.getters["auth/isAdministrador"];
    }
  },

  created() {
    this.fetchAllProjetos().then(() => { this.asyncDataStatus_fetched() });
  },
};
</script>

<style src="./Projetos.scss" lang="scss"/>
